import outlineDepan from "../assets/vehicle-outline-depan.svg";
import outlineKiri from "../assets/vehicle-outline-kiri.svg";
import outlineKanan from "../assets/vehicle-outline-kanan.svg";
import outlineBelakang from "../assets/vehicle-outline-belakang.svg";
import boxOutlineDepan from "../assets/trailer-box-outline-depan.svg";
import boxOutlineKiri from "../assets/trailer-box-outline-kiri.svg";
import boxOutlineKanan from "../assets/trailer-box-outline-kanan.svg";
import boxOutlineBelakang from "../assets/trailer-box-outline-belakang.svg";

// Generic outline per photo group, shown as the reference model when the jenis mobil has no uploaded photo.
// gambar_box_* are the photos of the trailer, a separate group from the vehicle's own gambar_*.
export const vehicleOutlinePlaceholders = {
  gambar_depan: outlineDepan,
  gambar_kiri: outlineKiri,
  gambar_kanan: outlineKanan,
  gambar_belakang: outlineBelakang,
  gambar_box_depan: boxOutlineDepan,
  gambar_box_kiri: boxOutlineKiri,
  gambar_box_kanan: boxOutlineKanan,
  gambar_box_belakang: boxOutlineBelakang,
};
